import API from '../../../../../services/api';

export const VARIABLES_API = {
    get: async () => {
        return await API.get('/variables').then(res => res.data);
    },
    update: async (variable) => {
        return API.put('/variables/' + variable.id, variable).then(res => res.data);
    }
}